// extracted by mini-css-extract-plugin
module.exports = {"item":"CustomAccordion_item__1KrZV","header":"CustomAccordion_header__3rrgB","content":"CustomAccordion_content__1hYw8"};